import { call, put, select, takeEvery, takeLatest } from "redux-saga/effects";
import { IDmMucHocPhiTinChiViewModelRequest } from "../../../model/request/category/dmMucHocPhiTinChiViewModelRequest";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import { rootActions } from "../../actions/rootActions";
import { mucHocPhiTinChiApi } from "./../../../api/category/mucHocPhiTinChiApi";
import { IDmMucHocPhiTinChi } from "./../../../model/respone/category/IDmMucHocPhiTinChi";
import {
  eDmMucHocPhiTinChiActionIds,
  IDmMucHocPhiTinChiActionTypes,
} from "./../../action-types/category/IDmMucHocPhiTinChiActions";
import { IDmMucHocPhiTinChiCopyRequest } from "../../../model/request/category/dmMucHocPhiTinChiCopyRequest";

export function* mucHocPhiTinChiSaga(): any {
  yield takeLatest(eDmMucHocPhiTinChiActionIds.LOAD_START, loadWorker);
  yield takeEvery(eDmMucHocPhiTinChiActionIds.SAVE_START, saveWorker);
  yield takeLatest(eDmMucHocPhiTinChiActionIds.LOCK_START, lockWorker);
  yield takeLatest(eDmMucHocPhiTinChiActionIds.UNLOCK_START, unlockWorker);
  yield takeLatest(eDmMucHocPhiTinChiActionIds.COPY_START, copyWorker);
}

function* loadWorker(action: IDmMucHocPhiTinChiActionTypes): any {
  const payload = action.payload as IDmMucHocPhiTinChiViewModelRequest;
  const res: IBaseRespone = yield call(mucHocPhiTinChiApi.Select, payload);
  if (res.is_success) {
    yield put(rootActions.category.mucHocPhiTinChi.LOAD_SUCCESS(res.data));
  } else {
    yield put(
      rootActions.category.mucHocPhiTinChi.LOAD_ERRR(res.message ?? "Có lỗi")
    );
  }
}

function* saveWorker(action: IDmMucHocPhiTinChiActionTypes): any {
  const payload = action.payload as IDmMucHocPhiTinChi[];
  const res = yield call(mucHocPhiTinChiApi.Save, payload);
  if (res) {
    if (res.is_success) {
      yield put(rootActions.category.mucHocPhiTinChi.SAVE_SUCCESS(res.data));
    } else {
      yield put(
        rootActions.category.mucHocPhiTinChi.SAVE_ERROR(res.message ?? "Có lỗi")
      );
    }
  }
}

function* lockWorker(action: IDmMucHocPhiTinChiActionTypes): any {
  const payload = action.payload as IDmMucHocPhiTinChiViewModelRequest;
  const res = yield call(mucHocPhiTinChiApi.Lock, payload);
  if (res) {
    if (res.is_success) {
      yield put(rootActions.category.mucHocPhiTinChi.LOCK_SUCCESS(res.data));
      // Khóa xong → làm mới danh sách theo bộ lọc hiện tại (lấy đúng trạng thái từ server).
      const request = yield select(
        (x: any) => x.category.mucHocPhiTinChi.request
      );
      if (request?.hoc_ky && request?.nam_hoc) {
        yield put(rootActions.category.mucHocPhiTinChi.LOAD_START(request));
      }
    } else {
      yield put(
        rootActions.category.mucHocPhiTinChi.LOCK_ERRR(res.message ?? "Có lỗi")
      );
    }
  }
}

function* unlockWorker(action: IDmMucHocPhiTinChiActionTypes): any {
  const payload = action.payload as IDmMucHocPhiTinChiViewModelRequest;
  const res = yield call(mucHocPhiTinChiApi.Unlock, payload);
  if (res) {
    if (res.is_success) {
      yield put(rootActions.category.mucHocPhiTinChi.UNLOCK_SUCCESS(res.data));
      // Mở khóa xong → làm mới danh sách theo bộ lọc hiện tại.
      const request = yield select(
        (x: any) => x.category.mucHocPhiTinChi.request
      );
      if (request?.hoc_ky && request?.nam_hoc) {
        yield put(rootActions.category.mucHocPhiTinChi.LOAD_START(request));
      }
    } else {
      yield put(
        rootActions.category.mucHocPhiTinChi.UNLOCK_ERRR(
          res.message ?? "Có lỗi"
        )
      );
    }
  }
}

function* copyWorker(action: IDmMucHocPhiTinChiActionTypes): any {
  const payload = action.payload as IDmMucHocPhiTinChiCopyRequest;
  const res = yield call(mucHocPhiTinChiApi.Copy, payload);
  if (res) {
    if (res.is_success) {
      yield put(rootActions.category.mucHocPhiTinChi.COPY_SUCCESS(res.data));
      // Sao chép xong → làm mới danh sách theo bộ lọc hiện tại.
      const request = yield select(
        (x: any) => x.category.mucHocPhiTinChi.request
      );
      if (request?.hoc_ky && request?.nam_hoc) {
        yield put(rootActions.category.mucHocPhiTinChi.LOAD_START(request));
      }
    } else {
      yield put(
        rootActions.category.mucHocPhiTinChi.COPY_ERROR(res.message ?? "Có lỗi")
      );
    }
  }
}
